module.exports = __webpack_public_path__ + "img/cul_6.7c88fbc0.png";